/* tslint:disable */
/* eslint-disable */
/**
 * HCL Commerce Services - Account and Contract
 * These services provide APIs to manage accounts and contracts.  a contract is an agreement that represents the terms and conditions that apply to a transaction. An account is a relationship between the merchant and the financial institution that processes transactions for that merchant.
 *
 * The version of the OpenAPI document: 9.1.6
 * 
 * (C) Copyright HCL Technologies Limited 2021
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import globalAxios, { AxiosPromise, AxiosInstance } from 'axios';
import { Configuration } from '../../../../../configuration';
// Some imports not used depending on template conditions
// @ts-ignore
import { DUMMY_BASE_URL, assertParamExists, setApiKeyToObject, setBasicAuthToObject, setBearerAuthToObject, setOAuthToObject, setSearchParams, serializeDataIfNeeded, toPathString, createRequestFunction } from '../../../../../common';
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, RequestArgs, BaseAPI, RequiredError } from '../../../../../base';
// @ts-ignore
import { CreateClaimRequest } from '../../../../../com/hcl/commerce/typescript/axios';
// @ts-ignore
import { CreateClaimResponse } from '../../../../../com/hcl/commerce/typescript/axios';
/**
 * CreateClaimApi - axios parameter creator
 * @export
 */
export const CreateClaimApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * Create claim
         * @summary Create claim
         * @param {string} storeId The store identifier.
         * @param {CreateClaimRequest} createClaimRequest The request object for project creation.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createClaim: async (storeId: string, createClaimRequest: CreateClaimRequest, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'storeId' is not null or undefined
            assertParamExists('createClaim', 'storeId', storeId)
            // verify required parameter 'createClaimRequest' is not null or undefined
            assertParamExists('createClaim', 'createClaimRequest', createClaimRequest)
            const localVarPath = `/store/{storeId}/reclaim/createClaim`
                .replace(`{${"storeId"}}`, String(storeId));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(createClaimRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * CreateClaimApi - functional programming interface
 * @export
 */
export const CreateClaimApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = CreateClaimApiAxiosParamCreator(configuration)
    return {
        /**
         * Create claim
         * @summary Create claim
         * @param {string} storeId The store identifier.
         * @param {CreateClaimRequest} createClaimRequest The request object for project creation.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createClaim(storeId: string, createClaimRequest: CreateClaimRequest, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CreateClaimResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createClaim(storeId, createClaimRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * CreateClaimApi - factory interface
 * @export
 */
export const CreateClaimApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = CreateClaimApiFp(configuration)
    return {
        /**
         * Create claim
         * @summary Create claim
         * @param {string} storeId The store identifier.
         * @param {CreateClaimRequest} createClaimRequest The request object for project creation.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createClaim(storeId: string, createClaimRequest: CreateClaimRequest, options?: any): AxiosPromise<CreateClaimResponse> {
            return localVarFp.createClaim(storeId, createClaimRequest, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * CreateClaimApi - object-oriented interface
 * @export
 * @class CreateClaimApi
 * @extends {BaseAPI}
 */
export class CreateClaimApi extends BaseAPI {
    /**
     * Create claim
     * @summary Create claim
     * @param {string} storeId The store identifier.
     * @param {CreateClaimRequest} createClaimRequest The request object for project creation.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CreateClaimApi
     */
    public createClaim(storeId: string, createClaimRequest: CreateClaimRequest, options?: any) {
        return CreateClaimApiFp(this.configuration).createClaim(storeId, createClaimRequest, options).then((request) => request(this.axios, this.basePath));
    }
}
